module.exports = __webpack_public_path__ + "static/media/logo.a60750b1.svg";